import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { keyFieldsSelector } from 'redux/keyFieldsSlice';
import {
  formatNameSelector,
  formatPropsSelector,
  inputSampleSelector,
  schemaFieldsSelector
} from 'redux/schemaSlice';
import { historyEntryAdded } from 'redux/historySlice';
import { getCalculateSizePayload } from 'utils/payloadUtils';
import { requestMetrics as requestCalculateSize } from 'api';

import { notify } from 'components/Alert';

const useMetricsRequest = () => {
  const dispatch = useDispatch();
  const keyFields = useSelector(keyFieldsSelector);
  const formatName = useSelector(formatNameSelector);
  const formatProps = useSelector(formatPropsSelector);
  const inputSample = useSelector(inputSampleSelector);
  const schemaFields = useSelector(schemaFieldsSelector);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return {
    isLoading,
    requestMetrics: async () => {
      try {
        setIsLoading(true);
        const metrics = await requestCalculateSize(
          getCalculateSizePayload(
            schemaFields,
            formatName,
            formatProps,
            keyFields,
            inputSample
          )
        );
        dispatch(historyEntryAdded({ metrics, inputSample }));
      } catch {
        notify({ message: 'Failed fetching metrics' });
        throw Error('Failed fetching metrics');
      } finally {
        setIsLoading(false);
      }
    }
  };
};

export default useMetricsRequest;
